<template lang="html">
<div>
  <r-score></r-score>
  <r-oil></r-oil>
  <r-smooth></r-smooth>
  <r-darkcircle></r-darkcircle>
  <r-pimple></r-pimple>
  <r-blackhead></r-blackhead>
  <img class="sr-a__link" @click="sendLog" src="./imgs/link.jpg" alt="点击体验"/>
  <r-footer></r-footer>
</div>
</template>

<script>
import Score from './score.vue'
import Oil from './oil.vue'
import Smooth from './smooth.vue'
import Pimple from './pimple'
import BlackHead from './blackhead.vue'
import Darkcircle from './darkcircle.vue'
import Footer from '@/components/common/footer/'

export default {
  components: {
    'r-score': Score,
    'r-oil': Oil,
    'r-smooth': Smooth,
    'r-pimple': Pimple,
    'r-blackhead': BlackHead,
    'r-darkcircle': Darkcircle,
    'r-footer': Footer
  },
  created () {
    (window.onload = function () {
      window.BD_MMS_SKILL.initSkill({
        tplName: 'skilllist',
        id: 'wrap',
        fontColor: '4b86f7',
        bgColor: 'fff'
      })
    })()
  },
  methods: {
    sendLog () {
      window.BD_MMS_SKILL.sendLog()
      console.log('test');
      (function () {
        window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=org.c2h4.afei.beauty'
      })()
    }
  }
}
</script>

<style>
html,body{
    height: 100%;
}
.clearfix::after{
    clear: both;
    display: table;
    content: '';
    visibility: hidden;
}
.layout-div__container{
    width: 100%;
    box-sizing: border-box;
    padding:0 4vw;
    margin-top: 13.3vw;
}

.layout-div__title{
    height: 7.5vw;
}
.layout-div__body{
    display: block;
    padding: 2.6666667vw 0;
}
.layout-i__line{
    float: left;
    width: 1.1vw;
    height: 4.8vw;
    background-color: #64c8c8;
    margin-right: 2.7vw;
    line-height: 6.9vw;
    margin-top: 1.5vw;
}
.layout-span__title__text{
    font-size: 5.333333vw;
    font-weight: bold;
    float: left;
    color: #000;
}

.layout-div__box{
    position:relative;
    padding: 5.3vw 0;
    width: 92.246%;
    height: 49vw;
    height: 49vw;
    display: block;
    margin: 0 auto;
    margin-top: 1.3rem;
    border-radius: 0.11rem;
    /* background:url(../imgs/report-img-skincareplan@2x.png) repeat scroll 0 0; */
    background-size:9.2rem 4.9rem;

}
.layout-div__box p{
    margin:0;
    color:#64c8c8;
    font-size: 5.3333333333vw;
    text-align: center;
}
.layout-div__box p{
    font-size: 16vw;
}
.layout-a__getcase{
    position:absolute;
    width: 84vw;
    background-color: #64c8c8;
    color: #fff !important;
    text-align: center;
    line-height: 12vw;
    border-radius: 26.7vw;
    display: block;
    text-decoration: none;
    font-weight: normal!important;
    font-size: 3.733333333vw;
    text-shadow: none!important;
    bottom: 5.3vw;
    left: 50%;
    margin-left: -42vw;
}
.layout-a__getcase{
    font-size: 42px;
}

.layout-div__footer{
    padding: 0.8rem 0 0.53rem 0;
}
.layout-div__footer p{
    text-align: center;
}
.layout-a__more{
    margin-top: 0.53rem;
    float: right;
    text-decoration: none;
    color: #3fa9a9!important;
    font-size: 14px;
}
.layout-a__more{
    font-size: 42px;
}
.layout-i__circle{
    width: 1.6vw;
    height: 1.6vw;
    border-radius: 50%;
    background-color: #64c8c8;
    display: inline-block;
    margin-right: 0.13rem;
    vertical-align: middle;
}
.layout-i__font{
    font-style: normal;
    color: #55bebc;
}
.big-font{
    font-size: 4.8vw;
    font-weight: bold;
    font-family: 'PingFang SC'
}
.small-font{
    font-size: 14px;
}

.layout-hide{
    display: none!important;
}
.you-look-so-good-today{
    display: inline-block;
    /* background: url('../imgs/logo@2x.png') no-repeat scroll 0 0; */
    background-size: 0.53rem 0.53rem;
    width: 0.53rem;
    height: 0.53rem;
    vertical-align: bottom;
}
.mask{
    width: 100%;
    height: 100%;
    position: absolute;
    top:0;
    left:0;
    background-color: rgba(0,0,0, .5);
    z-index: 9;
}
.layout-div__items{
    margin-top: 0.53rem;
}
.layout-p__introduce{
    margin-top: 0.53rem;
    font-size:15px;
    color: #646464;
}
.sc-p__introduce{
    font-size: 45px;
}

.layout-h4__items__title{
    font-size: 13px;
    color: #64c8c8;
    text-shadow: none;
    font-weight: normal;
}
.layout-h4__items__title{
    font-size: 39px;
}
.layout-ul__items__group{
    margin-top: 0.4rem;
}
.layout-li__item__detail{
    width: 100%;
    padding:0.27rem 0;
    border-bottom: 0.03rem solid #eee;
}
.layout-img__item__img{
    width: 2.67rem;
    height: 2.67rem;
    float: left;
}
.layout-div__item__descrip{
    width: 4.16rem;
    float: left;
    padding: 0.13rem;
}
.layout-div__item__descrip h4{
    font-size: 15px;
    line-height: 1.4;
    color: #323232;
    padding-bottom: 0.13rem;
}
.layout-div__item__descrip p{
    font-size: 12px;
    color: #b4b4b4;
}
.layout-div__item__match{
    float: right;
    padding: 0.16rem;
    width:1.39rem;
}
.layout-canvas__item{
    display: block;
    width: 1.39rem;
    height: 1.39rem;
    margin-right: auto;
    margin-left:  auto;
}
.layout-div__item__match span{
    display: block;
    width: 100%;
    margin-top: 0.27rem;
    font-size: 12px;
    color: #64c8c8;
    text-align: center;
}
.layout-ul__case__group{
    width: 100%;
}
.layout-li__case__item{
    width: 100%;
    padding: 0.53rem 0;
    border-bottom: 1px solid #eee;
}
.layout-img__case__img{
    float:left;
    width:3.2rem;
    height:1.8rem;
}
.layout-div__case__description{
    margin-left: 0.27rem;
    width: 5.7rem;
    float:right;
}
.layout-h4__case__title{
    font-size: 14px;
    color: #323232;
    padding-bottom: 0.27rem;
}
.layout-p__case__text{
    font-size: 12px;
    color: #a5a5a5;
}

.layout-div__loading{
    height: 100%;
}
.layout-canvas__loading{
    width: 6.27rem;
    height: 6.27rem;
    position:absolute;
    top: 50%;
    margin-top:-3.135rem;
    left: 50%;
    margin-left: -3.135rem;
}
.sr-a__link {
  width: 100%;
  display: block;
  margin-top: 21.333333333vw;
  margin-bottom: 10.666666667vw;
}
</style>



// WEBPACK FOOTER //
// src/components/Result/index.vue